import { get } from 'lodash';
import getClientInstance from '../../../app/config/apollo-client';
import TAS_INITIATE_REFERRAL_MUTATION from './mutations/tas_initiate_referral.graphql';

const sendReferral = (params)  => {
  const {
    note,
    selectedService,
    memberId,
    consultationId,
  } = params

  const formData = {
    note: note, 
    service: selectedService, 
    memberId: memberId,
    consultationId: consultationId,
  };

  const apolloClient = getClientInstance();

  const promise = 
    apolloClient.mutate({
      mutation: TAS_INITIATE_REFERRAL_MUTATION,
      variables: { formData: formData }
    })
    .then((response) => {
      const data = get(response, 'data.initiateReferral');

      return data;
    })

  return promise;
};

export default sendReferral;
